var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.itemsMensagemPronta,"loading":_vm.loading,"label":"Mensagem Pronta*","rules":_vm.rules},model:{value:(_vm.mensagemPronta),callback:function ($$v) {_vm.mensagemPronta=$$v},expression:"mensagemPronta"}})}
var staticRenderFns = []

export { render, staticRenderFns }